import { ThemeProvider } from '@material-ui/core';
import { createTheme } from "@material-ui/core/styles";
import axios from "axios";
import MaterialTable from "material-table";
import { Component } from "react";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import ConfirmModal from "../utils/ConfirmModal";
import { hasPermission } from "../utils/usePermission";
import { DateTimeFormat } from './DateFormat/DateTimeFormat';
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";

export default class UOMList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uoms: [],
      loading: false,
      showToast: false,
      toastMessage: "",
      color: '',
      toastVariant: "",
      showConfirm: false,
      deleteId: null,
    };
  }
  openConfirmModal = () => {
    this.setState({ showConfirm: true, });
  };
  closeConfirmModal = () => {
    this.setState({ showConfirm: false });
  };

  componentDidMount() {
    this.fetchUOMs();
  }

  fetchUOMs = () => {
    this.setState({ loading: true });
    axios({
      method: 'get',
      url: '/uoms',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({
          uoms: res.data,
          loading: false
        })
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error fetching UOMs",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };

  handleDelete = () => {
    this.setState({ loading: true });
    const token = localStorage.getItem("token");
    axios
      .delete(`/uoms/${this.state.deleteId} `, { headers: { Authorization: `Bearer ${token} ` } })
      .then(() => {
        this.setState({
          showConfirm: false,
          showToast: true,
          toastMessage: "UOM deleted successfully",
          toastVariant: "success",
          deleteId: null,
          color: 'green',
          loading: false,
        });
        this.fetchUOMs();
      })
      .catch((error) => {
        this.setState({
          showToast: true,
          toastMessage: error.response?.data?.message || "Error deleting UOM",
          toastVariant: "danger",
          color: 'red',
          showConfirm: false,
          deleteId: null,
          loading: false,
        });
      });
  };

  handleMoveAdd = () => {
    this.props.history.push('/uom-add')
  }

  handleEdit = (rowData) => {
    const { id } = rowData;
    this.props.history.push(`/uom-add/${id}`, { data: rowData });
  };

  render() {
    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <ConfirmModal
          show={this.state.showConfirm}
          onHide={() => this.setState({ showConfirm: false, deleteId: null })}
          onConfirm={() => this.handleDelete()}
          title="Delete Confirmation"
          loading={this.state.loading}
          message="Are you sure you want to delete this UOM?"
        />
        <CommonLoader isLoading={this.state.loading}>
          <div className="container-fluid pt-4">
            <div className='d-flex search-btn-gap'>
              {
                hasPermission('M17S1B1') && (
                  <div className='add-role'>
                    <Button onClick={this.handleMoveAdd} variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button"> <i className="fa fa-plus-circle"></i> Add UOM</Button>
                  </div>
                )
              }
            </div>
            <div className="col-sm-12">
              <Card>
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <div className="panel-title">
                    <strong>UOM List</strong>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      title="UOM List"
                      columns={[
                        { title: "ID", field: "id", editable: "never" },
                        { title: "Name", field: "name" },
                        {
                          title: "Created Date", field: "createdAt",
                          render: (text) => DateTimeFormat(text.createdAt),
                        },
                        {
                          title: 'Action',
                          render: rowData => (
                            <>
                              {hasPermission('M17S1B3') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Edit UOM</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-info" className="mr-2 info"
                                    onClick={() => this.handleEdit(rowData)}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                              {hasPermission('M17S1B2') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Delete UOM</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-danger" className="mr-2 delete-btn"
                                    onClick={() => this.setState({ showConfirm: true, deleteId: rowData.id })}
                                  // onClick={() => this.handleDelete(rowData.id)}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}

                            </>
                          )
                        }
                      ]}
                      data={this.state.uoms}

                      // actions={[
                      //   // {
                      //   //   icon: "add",
                      //   //   tooltip: "Add UOM",
                      //   //   isFreeAction: true,
                      //   //   onClick: () => this.props.history.push("/uom-add"),
                      //   // },
                      //   // {
                      //   //   icon: "delete",
                      //   //   tooltip: "Delete UOM",
                      //   //   onClick: (event, rowData) => this.handleDelete(rowData.id),
                      //   // },

                      // ]}
                      options={{
                        pageSizeOptions: [10, 20, 30, 50, 75, 100],
                        pageSize: 10,
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        actionsColumnIndex: -1,
                        search: true,
                        paging: true,
                      }}
                    />
                  </ThemeProvider>
                </Card.Body>
              </Card>
            </div>
          </div>
        </CommonLoader >
      </>
    );
  }
}
